var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMscanRivileBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1201.73 1054.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0d0708;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #231e21;\n      }\n\n      .cls-3 {\n        fill: #00b373;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m162.83,671.1c0-36.88-28.18-62.28-70.63-62.28H1.73v208.43h43.48v-77.94h33.42l42.45,78.29h48.38l-50.1-87.34c27.13-11.86,43.47-31.32,43.47-59.16Zm-79.67,33.76h-37.95v-61.24h37.95c22.61,0,35.49,10.78,35.49,28.88,0,20.18-12.88,32.36-35.49,32.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 269.78,
    y: 608.82,
    width: 43.49,
    height: 208.78
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "499.56 756.01 452.23 608.82 406.63 608.82 479.37 817.6 518 817.6 591.07 608.82 547.22 608.82 499.56 756.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 684.58,
    y: 608.82,
    width: 43.49,
    height: 208.78
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "885.42 608.82 841.92 608.82 841.92 817.6 963.38 817.6 963.38 781.06 885.42 781.06 885.42 608.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1201.73 645.01 1201.73 608.82 1062.89 608.82 1062.89 817.6 1201.73 817.6 1201.73 781.76 1106.04 781.76 1106.04 728.87 1198.58 728.87 1198.58 694.07 1106.04 694.07 1106.04 645.01 1201.73 645.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 210.51,
    y: 86.97,
    width: 417.56,
    height: 43.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.73,
    y: 434.87,
    width: 208.78,
    height: 43.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.73,
    y: 347.9,
    width: 208.78,
    height: 43.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.73,
    y: 260.92,
    width: 626.35,
    height: 43.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 210.51,
    y: 173.95,
    width: 417.56,
    height: 43.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 210.51,
    width: 417.56,
    height: 43.49
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m149.38,986.78v65.72h-22.23v-60.26c0-14.63-6.43-22.04-19.5-22.04s-21.45,10.14-21.45,26.72v55.58h-22.04v-60.26c0-14.63-6.43-22.04-19.5-22.04s-22.43,10.14-22.43,26.72v55.58H0v-100.62h19.7l1.75,13.07h.78c6.24-9.95,15.99-14.82,29.06-14.82,14.24,0,24.38,5.26,30.23,15.8h.58c6.43-10.53,16.96-15.8,31.4-15.8,22.04,0,35.88,14.04,35.88,36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m169.26,1018.96h22.23c0,9.95,7.8,16.19,20.48,16.19s19.31-3.71,19.31-11.31c0-5.85-4.48-9.75-13.26-11.5l-17.75-3.32c-18.53-3.71-27.89-13.65-27.89-29.64,0-16.96,14.82-29.25,38.81-29.25s40.17,13.46,40.17,32.96h-21.84c-.58-9.36-7.21-15.02-18.72-15.02-10.14,0-16.77,4.29-16.77,11.51,0,5.85,4.49,9.55,13.26,10.92l17.16,3.32c19.31,4.09,29.25,12.09,29.25,30.03,0,9.56-3.9,16.97-11.89,22.43-7.8,5.26-17.75,8-29.84,8-26.52,0-42.12-13.65-42.71-35.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m281.38,1040.21c-8.39-9.55-12.48-22.23-12.48-38.03,0-31.79,17.16-52.07,47.39-52.07,27.11,0,42.12,15.6,43.68,38.42h-22.23c-.98-11.51-8.97-18.72-21.45-18.72-16.58,0-24.77,12.09-24.77,32.37s8.19,32.57,24.77,32.57c12.48,0,20.28-7.02,21.65-18.72h22.23c-1.76,23.21-16.77,38.22-43.29,38.22-15.21,0-27.11-4.68-35.49-14.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m384.73,1045.48c-6.24-6.04-9.36-13.46-9.36-22.62,0-18.72,13.65-31.2,41.15-31.2h23.4v-6.04c0-10.14-6.63-17.16-19.89-17.16-11.7,0-18.72,6.44-18.92,15.02h-21.06c0-19.5,15.41-33.35,40.37-33.35,12.87,0,23.01,3.32,30.42,9.95s11.12,15.02,11.12,25.35v67.08h-19.5l-1.56-11.9h-.78c-6.24,9.17-16.19,13.65-29.64,13.65-10.73,0-19.31-2.92-25.74-8.78Zm55.19-31.01v-6.83h-22.43c-13.26,0-19.89,4.88-19.89,14.43,0,8.58,6.24,14.43,17.94,14.43,14.63,0,24.38-9.75,24.38-22.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m488.47,1052.5v-100.62h19.7l1.75,13.07h.78c6.24-9.95,15.99-14.82,29.45-14.82,22.43,0,36.27,14.04,36.27,36.66v65.72h-22.23v-60.26c0-14.63-6.83-22.04-20.48-22.04s-23.01,10.14-23.01,26.72v55.58h-22.23Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMscanRivileBlack);
export default __webpack_public_path__ + "static/media/mscan-rivile-black.bb6fd2c229550e9066693219698d62f9.svg";
export { ForwardRef as ReactComponent };